import { Directus } from '@directus/sdk';
import DonationContactText from './models/DonationButtonData';
export default class DirectusCmsDonationsApi {
    static getInstance(basePath) {
        if (this.instance)
            return this.instance;
        if (!basePath) {
            basePath = process.env.CMS_URL;
        }
        const instance = new DirectusCmsDonationsApi();
        instance.api = new Directus(basePath);
        return (this.instance = instance);
    }
    async getButtonData(lang) {
        var _a;
        const response = await ((_a = this.api) === null || _a === void 0 ? void 0 : _a.items('donation_contact').readOne(1, {
            fields: ['*.*'],
            deep: {
                translations: { _filter: { languages_code: { lang: { _eq: lang } } } }
            }
        }));
        return DonationContactText.fromApi(response);
    }
}
